import React from 'react';

import Page from 'components/page';
import SectionContainer from 'components/sectionContainer';
import TrybesMenList from 'components/trybesMenList';
import JoinUs from 'components/joinUs';

const TrybesMenPage = () => {
  return (
    <Page pageName="trybesMen">
      <SectionContainer>
        <JoinUs />
        <TrybesMenList />
      </SectionContainer>
    </Page>
  );
};

export default TrybesMenPage;
